import React from "react";

const InAppBanner = (props: { text: string }) => {
  const { text } = props;

  return <div className="dashboard_banner">{text}</div>;
};

export default InAppBanner;
